import "./About.scss";
import Tags from "../../UI/Tags/Tags";
import TiltedCard from "../../UI/TiltedCard/TiltedCard";
import aboutImg from "/images/about.jpg";
import aboutImg2x from "/images/about@2x.jpg";
import BorderCircle from "../../UI/BorderCircle/BorderCircle";
import techStack from "./techStack";

const About = () => {
  return (
    <section className="about" id="about">
      <div className="container">
        <div className="about__wrapper">
          <div className="about__content">
            <BorderCircle>
              <h2 className="about__title">Обо мне</h2>
            </BorderCircle>

            <div className="about__description">
              <Tags tag="p" />
              <br></br>
              <span className="about__desc about__desc--xl about__desc--color">
                Привет!
              </span>
              <p className="about__desc">
                Я&nbsp;frontend-разработчик, специализирующийся на&nbsp;создании
                современных веб-приложений и&nbsp;сервисов, которые помогают
                бизнесу расти. В&nbsp;работе использую{" "}
                {techStack.map((tech, index) => (
                  <span key={tech} className="about__desc about__desc--color">
                    {tech}
                    {index < techStack.length - 1 && ", "}
                  </span>
                ))}
                . Интегрирую сторонние библиотеки, пишу чистый
                и&nbsp;поддерживаемый код, оптимизирую интерфейсы под разные
                устройства и&nbsp;уделяю внимание деталям, чтобы продукт был
                не&nbsp;только функциональным, но&nbsp;и&nbsp;удобным для
                пользователя.
                <br></br>
                <Tags tag="/p" />
              </p>
            </div>
          </div>
          <TiltedCard
            imageSrc={aboutImg}
            imageSrc2x={aboutImg2x}
            altText="About"
            containerHeight="556px"
            containerWidth="462px"
            // containerWidth="23.6vw"
            imageHeight="556px"
            imageWidth="462px"
            // imageWidth="23.6vw"
            rotateAmplitude={12}
            scaleOnHover={1.2}
            showMobileWarning={false}
            showTooltip={false}
            displayOverlayContent={true}
          />
        </div>
      </div>
    </section>
  );
};

export default About;